import { referralTypes } from '../types/refferalTypes'
import referralService from 'src/services/referral'

export const getMyRefDetailsSuccess = (data: {}) => {
  return {
    type: referralTypes.GET_MY_REFERRALS_DETAILS_REQUEST_SUCCESS,
    payload: data,
  }
}

export const getMyRefDetailsAction = () => {
  return async (dispatch: any) => {
    try {
      const response: any = await referralService.getReferralCode()
      dispatch(getMyRefDetailsSuccess(response.data.data))
    } catch (error) {
      console.log(error)
    }
  }
}
